/* eslint-disable no-shadow */
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  Drawer,
  CircularProgress,
  useMediaQuery,
  Grid,
  Button,
  List,
  ListSubheader,
} from "@mui/material";
import { useLogoutMutation } from "../../../../../graphql/generated/graphql";

import { setAuth } from "../../../../hooks/auth";
import { clearToken, clearRefreshToken } from "../../../../helper/auth";
import NavItem from "./nav-item";
import { LogoSVG } from "../../../../assets/svg";
import { theme } from "../../..";
import routes from "../../../../config/routers/routes";
import { useLoginState } from "../../../../hooks/loginInfo";
import { useApolloClient } from "@apollo/client";


const heightValue = 64;
const widthValue = 280;

const DashboardSidebar = (props: any) => {
  const client = useApolloClient();
  const loginState = useLoginState();
  const location = useLocation();
  const navigate = useNavigate();
  const { open, onClose } = props;
  const [loader, setLoader] = useState(false);
  const [logoutMutation] = useLogoutMutation();
  const lgUp = useMediaQuery(theme.breakpoints.up("md"));

  const handleLogout = async () => {
    setLoader(true);
    try {
      await logoutMutation();
      client.cache.reset();
      client.clearStore();
      clearToken();
      clearRefreshToken();
      setAuth(false);
      navigate("/");
    } catch (e) {
      setLoader(false);
    }
  };

  const currentRol = loginState.user_type.get();
  const listItems = routes
    .itemsAdmin(currentRol)
    .map((item) => (
      <NavItem
        icon={item.icon}
        href={item.href}
        title={item.title}
        active={location.pathname.includes(item.href)}
        child={item.child}
        key={item.title}
      />
    ));

  const content = (
    <>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <section>
          <Box
            sx={{
              background: "#000102",
              height: heightValue,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              href="/"
              sx={{
                width: "80%",
              }}
            >
              <LogoSVG />
            </IconButton>
          </Box>
        </section>
        <section>
          <Grid
            sx={{
              height: `calc( 100vh - ${heightValue}px)`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            <List
              sx={{ width: "100%" }}
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader
                  component="div"
                  id="nested-list-subheader"
                  sx={{
                    background: "transparent",
                    color: "#fff",
                  }}
                >
                  Project Overview
                </ListSubheader>
              }
            >
              {listItems}
            </List>
            <Box>
              <Box sx={{ flexGrow: 1 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  onClick={handleLogout}
                >
                  {loader ? <CircularProgress color="primary" /> : "Log Out"}
                </Button>
              </Box>
            </Box>
          </Grid>
        </section>
      </Grid>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: "#323643",
            color: "#FFFFFF",
            width: widthValue,
            maxWidth: "80%",
          },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "#323643",
          color: "#FFFFFF",
          width: widthValue,
          maxWidth: "80%",
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

export default DashboardSidebar;
